export default "__VITE_ASSET__CcxifAJo__"